"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataProtectionImpactAssessmentStatus = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
/**
 * The status of a DPIA with a particular processing activity
 */
exports.DataProtectionImpactAssessmentStatus = (0, type_utils_1.makeEnum)({
    /** There is a link associated with this processing activity's DPIA */
    Link: 'LINK',
    /** There is no DPIA required for this processing activity */
    NotRequired: 'NOT_REQUIRED',
    /** The DPIA for this processing activity is missing */
    Missing: 'MISSING',
});
//# sourceMappingURL=processingActivity.js.map